module.exports = __webpack_public_path__ + "img/sankaku_2_red.772b6366.png";